import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface UIState {
  currentScreen: "home" | "cart" | "checkout" | "success" | "error" | "no-internet"
  showItemDetails: boolean
  showLoginModal: boolean
  showProductModal: boolean
  selectedItem: any | null
  language: "ar" | "en"
  orderData: any | null
}

const initialState: UIState = {
  currentScreen: "home",
  showItemDetails: false,
  showLoginModal: false,
  showProductModal: false,
  selectedItem: null,
  language: "ar",
  orderData: null,
}

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setCurrentScreen: (state, action: PayloadAction<UIState["currentScreen"]>) => {
      state.currentScreen = action.payload
    },
    setShowItemDetails: (state, action: PayloadAction<boolean>) => {
      state.showItemDetails = action.payload
    },
    setShowLoginModal: (state, action: PayloadAction<boolean>) => {
      state.showLoginModal = action.payload
    },
    setShowProductModal: (state, action: PayloadAction<boolean>) => {
      state.showProductModal = action.payload
    },
    setSelectedItem: (state, action: PayloadAction<any>) => {
      state.selectedItem = action.payload
    },
    setLanguage: (state, action: PayloadAction<"ar" | "en">) => {
      state.language = action.payload
    },
    setOrderData: (state, action: PayloadAction<any>) => {
      state.orderData = action.payload
    },
  },
})

export const { setCurrentScreen, setShowItemDetails, setShowLoginModal, setShowProductModal, setSelectedItem, setLanguage, setOrderData } = uiSlice.actions
export default uiSlice.reducer
